import * as React from 'react';
export const controlSvg = React.forwardRef(function controlSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.5 8a3.5 3.5 0 1 1-3.418 4.25H2.625a.75.75 0 0 1 0-1.5h5.457A3.5 3.5 0 0 1 11.5 8Zm0 1.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM4.5 1a3.5 3.5 0 0 1 3.418 2.75h5.457a.75.75 0 0 1 0 1.5H7.918A3.5 3.5 0 1 1 4.5 1Zm0 1.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z',
    }),
  );
});
controlSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var control = {
  category: 'icon',
  colorable: true,
  name: 'control',
  svg: controlSvg,
};
